export default __webpack_public_path__ + "8d2af28b90b12f4d3e30fe3f288e265b.pdf";